import {
  Category,
  ISpaceTypeCategory,
  ISpaceTypeSubcategory,
  Subcategory,
} from 'spw-redux/modules/space_types/types';
import { camelCase } from 'lodash';
import {
  IProjectSpaceTypeCategory,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';
import { CUSTOM_SUBCATEGORY } from 'spw-constants';

export const getDefaultSpaceTypeCategory = (
  defaultSpaceTypeCategory: ISpaceTypeCategory | ISpaceTypeSubcategory
) => {
  return {
    ...defaultSpaceTypeCategory,
    category: camelCase(defaultSpaceTypeCategory.category) as Category,
  };
};

const getDefaultSpaceTypeSubcategory = (
  defaultSpaceTypeCategory: ISpaceTypeSubcategory
): ISpaceTypeSubcategory => {
  return {
    ...defaultSpaceTypeCategory,
    category: camelCase(defaultSpaceTypeCategory.category) as Subcategory,
  };
};

export const camelCaseSpaceTypeCategories = (
  spaceTypeCategories: IProjectSpaceTypeCategory[]
): IProjectSpaceTypeCategory[] => {
  return spaceTypeCategories.map(
    (spaceTypeCategory: IProjectSpaceTypeCategory) => ({
      ...spaceTypeCategory,
      defaultSpaceTypeCategory: getDefaultSpaceTypeCategory(
        spaceTypeCategory.defaultSpaceTypeCategory
      ),
      subcategories: spaceTypeCategory.subcategories?.map(
        (subCategory: IProjectSpaceTypeSubcategory) => ({
          ...subCategory,
          defaultSpaceTypeCategory: getDefaultSpaceTypeSubcategory(
            subCategory.defaultSpaceTypeCategory
          ),
        })
      ),
    })
  );
};

export const hasCustomSubcategory = (
  projectSpaceTypeCategory: IProjectSpaceTypeCategory
) => {
  return projectSpaceTypeCategory.subcategories?.find(
    (subcategory: IProjectSpaceTypeSubcategory) =>
      subcategory.defaultSpaceTypeCategory.category === CUSTOM_SUBCATEGORY
  );
};
